module.exports = __webpack_public_path__ + "static/media/29GalleryPuppets.cd0410f2.jpeg";